import { DialogHeading } from '@ariakit/react';
import { Link } from 'react-router';

import ChevronIcon from '~/assets/icons/Chevron';
import { DialogDismiss } from '~/components/Dialog';
import Icon from '~/legacy/components/Icon';

type Props = {
  colour?: 'black' | 'white';
  heading?: string;
  hideDismiss?: boolean;
  onBack?: () => void;
  onDismissHref?: string;
};

export default function ModalNav({
  colour = 'black',
  heading,
  onBack,
  onDismissHref,
  hideDismiss
}: Props) {
  return (
    <nav
      className="flex w-full flex-row items-center justify-between"
      style={{ color: colour }}
    >
      <span className="flex min-w-6 shrink items-center justify-start self-stretch">
        {onBack && (
          <button
            className="flex w-full rotate-90 justify-center"
            onClick={onBack}
          >
            <ChevronIcon stroke={colour} width="14" height="14" />
          </button>
        )}
      </span>

      <div className="flex w-full flex-col items-center gap-4 text-center">
        <DialogHeading className="text-title-sm flex flex-col content-center self-stretch">
          {heading}
        </DialogHeading>
      </div>

      <span className="flex min-w-6 shrink items-center justify-end self-stretch">
        {!hideDismiss &&
          (onDismissHref ? (
            <Link to={onDismissHref}>
              <Icon
                name="close"
                width="12"
                height="12"
                viewBox="457 457 878 878"
                fill={colour}
              />
            </Link>
          ) : (
            <DialogDismiss>
              <Icon
                name="close"
                width="12"
                height="12"
                viewBox="457 457 878 878"
                fill={colour}
              />
            </DialogDismiss>
          ))}
      </span>
    </nav>
  );
}
